/**
 * Lintier product gallery — height follows the active slide (mobile).
 *
 * Horizon stretches every slide of the product gallery to the tallest
 * media, so a square photo sits letterboxed inside a 9:16 video's box.
 * On narrow screens the track is sized to whichever slide is in view
 * instead: each slide keeps its own aspect ratio (CSS), and this sets
 * the track height to the active slide's height, capped so a tall
 * portrait never exceeds the screen. The height change animates (CSS).
 */
(function () {
  var track = document.querySelector('media-gallery slideshow-slides');
  if (!track) return;

  var narrow = window.matchMedia('(max-width: 749px)');
  var VIEWPORT_ALLOWANCE = 120; /* room for the header above and the dots below */

  function activeSlide() {
    var slides = track.children;
    var centre = track.scrollLeft + track.clientWidth / 2;
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      if (s.offsetLeft <= centre && s.offsetLeft + s.offsetWidth > centre) return s;
    }
    return slides[0] || null;
  }

  function fit() {
    if (!narrow.matches) {
      track.style.height = '';
      return;
    }
    var slide = activeSlide();
    if (!slide) return;
    var natural = slide.offsetHeight;
    if (!natural) return;
    var cap = window.innerHeight - VIEWPORT_ALLOWANCE;
    track.style.height = Math.round(Math.min(natural, cap)) + 'px';
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = requestAnimationFrame(function () {
      pending = null;
      fit();
    });
  }

  document.addEventListener('slideshow:select', schedule);
  track.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  narrow.addEventListener ? narrow.addEventListener('change', schedule) : narrow.addListener(schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fit);
  } else {
    fit();
  }
  window.addEventListener('load', fit);
})();
